import React, { useEffect, useRef, useState } from "react";
import { Form as DhxForm } from "dhx-suite";
import { parseQueryString, setSearchingParams } from "../utils/queryStringHelper";
import { Mode } from "models";

interface SearchFormProps {
    searchText: string;
    onChange: (text: string) => void;
}

const formConfig = {
    cols: [
        {
            id: "searchText",
            type: "input",
            labelWidth: 0,
            icon: "mdi mdi-magnify",
            placeholder: "Type to search...",
            labelInline: true
        }
    ]
};

export const SearchForm = ({ searchText, onChange }: SearchFormProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const [form, setForm] = useState<DhxForm>();

    useEffect(() => {
        if (ref.current && !form) {
            const theForm = new DhxForm(ref.current, formConfig);
            if (searchText) {
                theForm.setValue({ searchText });
            }
            setForm(theForm);
        }

        if (form) {
            form.events.on("change", (_, value: string) => {
                if (value !== searchText) {
                    const splited = value.split(" ");
                    const filterTags: string[] = [];
                    let text = ""
                    splited.forEach(t => {
                        if (t.startsWith("#")) {
                           return filterTags.push(t.substring(1))
                        }
                        return text += `${t} `
                    });
                    const qs = parseQueryString(location.href.split('?')[1] || "");
                    setSearchingParams(filterTags.length ? filterTags : undefined, text.trim(), qs.mode as Mode);
                    onChange(value);
                }
            });

            return () => form.events.detach("change");
        }

        return undefined;
    });

    useEffect(() => {
        if (searchText && form) {
            form.setValue({ searchText: searchText });
        }
    }, [searchText]);

    useEffect(() => {
        setTimeout(() => {
            (ref.current!.querySelector("#searchText") as HTMLInputElement).focus();
        }, 200);
    }, []);

    return <div className="st-search--form" ref={ref}/>;
};
